module.exports = __webpack_public_path__ + "static/media/aicte.1a729971.png";